import { sanitiseUrl } from "common/Utils/sanitiseUrl";
import { FC } from "react";
import { LogoWrapper } from "./CommercialBadge.styled";

interface CommercialBadgeProps {
  image?: {
    data: { url: string; alt: string | null; title: string | null };
  } | null;
  term?: {
    name: string;
    url: string | null;
    id: number;
    uuid: string;
    bundle: string;
  } | null;
  link?: string | null;
}

const CommercialBadge: FC<CommercialBadgeProps> = ({ image, term, link }) => {
  const badgeImage = image?.data?.url ? (
    <img
      src={image.data.url}
      alt={image.data.alt || image.data.title || "Commercial Badge"}
    />
  ) : null;

  const shouldShow = Boolean(term || link || badgeImage);
  if (!shouldShow) return null;

  let badgeContent = null;

  if (link && badgeImage) {
    badgeContent = (
      <a href={sanitiseUrl(link)} target="_blank" rel="noopener noreferrer">
        {badgeImage}
      </a>
    );
  } else if (badgeImage) {
    badgeContent = badgeImage;
  }

  return (
    <LogoWrapper>
      {term && <p>{term.name}</p>}
      {badgeContent}
    </LogoWrapper>
  );
};

export default CommercialBadge;
